import {Product, Variant} from "../../../../models/product";
import {Component, h} from "preact";
import {connect} from "redux-zero/preact";
import actions from "../../../../store/actions";
import styles from './style.module.scss';
import {productService} from "../../../../services/product-service";
import ProductBrand from "../../../product-brand";
import Button from "../../../button";
import {icons} from "../../../icons";
import Colors from "../../../colors";
import {i18nService} from "../../../../services/i18n-service";
import MatchingProducts from "../../../matching-products";
import {customerService} from "../../../../services/customer-service";
import {Like} from "../../../../models/customer";
import {NY_CountryService} from "../../../../services/country-service";
import App from "../../../app";
import {Dimension, NY_Tracker} from "../../../../services/tracking-service";
import {ProductPrice} from "../../../product-price";
import {ShootingSize} from "../../../shooting-size";
import {config} from "../../../../config";
import {shortenerSerivce} from "../../../../services/shortener-service";
import {Epr, EprOpenedTrackingEvent} from "../../../epr";
import {CustomerShareType} from "../../../../services/web-site-customer-service";
import {useSingleClick} from "../../../event/single-event-filter";

interface Props {
  toggleLike(variant: Variant, newLikeState: boolean, dimension: string);

  product: Product;
  variant: Variant;
  likes: Like[];
}

interface State {
  showShareButtons: boolean;
  isLiked: boolean;
  isMaterialExpanded: boolean;
  isDisposalHintExpanded: boolean;
  showEpr: boolean;
}

const mapToProps = ({likes}) => ({likes});

class ProductInfoMobile extends Component<Props, State> {

  state: State = {
    showShareButtons: false,
    isLiked: false,
    isMaterialExpanded: false,
    isDisposalHintExpanded: false,
    showEpr: false
  };

  async componentDidMount() {
    this.updateLikeState();
  }

  componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<State>, previousContext: any): void {
    if (this.state.isLiked !== customerService.isVariantLiked(this.props.variant, this.props.likes)) {
      this.updateLikeState();
    }

    if (previousProps.product != this.props.product || previousProps.variant != this.props.variant) {
      this.setState({
        isMaterialExpanded: false,
        isDisposalHintExpanded: false,
      })
    }
  }

  private updateLikeState() {
    if (this.props.variant) {
      this.setState({isLiked: customerService.isVariantLiked(this.props.variant, this.props.likes)})
    }
  }

  private canShare() {
    return !!navigator.share;
  }

  private async share() {
    const shareURL = await shortenerSerivce.shorten(`${config.shareBasePath}/product/${this.props.variant.productId}/${this.props.variant.id}?country=${App.countryCode}`);

    await navigator.share({
      title: `${i18nService.translate(productService.getTranslationKey(this.props.product))} | ${this.props.variant.getColorTranslation()} | NEW YORKER`,
      url: shareURL.shortUrl
    });

    await customerService.shareItem(CustomerShareType.product, shareURL.shortUrl);
  }

  private showEpr() {
    this.setState({showEpr: true})
    NY_Tracker.trackClick(EprOpenedTrackingEvent);
  }

  render() {
    const variant = this.props.variant;
    return (
      <div>
        <div className={styles['product-info']}>
          <div className={styles["description"]}>
            {i18nService.translate(productService.getTranslationKey(this.props.product))}
          </div>

          <ProductPrice variant={variant} styles={styles}/>

          {NY_CountryService.showVariablePriceCaption(App.countryCode) && (
              <p className={styles['price-caption']}>
                {i18nService.translate('variable_price_caption')}
              </p>
          )}

          <div className={styles['brand-product-number']}>
            <div className={styles["brand"]}>
              <ProductBrand product={this.props.product}/>
            </div>
            <div className={styles['product-number']}>
              {variant.productId}
            </div>
          </div>

          <div className={styles["separator"]}/>

          <div class={styles['like-share']}>
            {!NY_CountryService.isRestricted(App.countryCode) && (<div class={styles['like']}>
              <Button svg={this.state.isLiked ? icons.renderHeartIcon() : icons.renderOutlineHeartIcon()}
                      label={i18nService.translate(this.state.isLiked ? 'detail_view_dislike_button' : 'detail_view_like_button')}
                      onClickCallback={useSingleClick(this.handleToggleLike.bind(this))}
                      red={true}
              />
            </div>)}

            {this.canShare() && (
              <div
                className={`${!NY_CountryService.isRestricted(App.countryCode) ? styles['share'] : styles['only-share']} `}>
                <Button svg={icons.renderShareIcon()} label={i18nService.translate('detail_view_share_button')}
                        onClickCallback={this.share.bind(this)} white={true}/>
              </div>
            )}
          </div>

          <div class={styles["separator"]}/>

          {(this.props.variant.components.length > 0 || NY_CountryService.getCountryCode() == "fr") && (
            <>
              <div className={styles["additional-container"]}>
                <div
                  className={styles["title"]}
                  onClick={() => this.setState({isMaterialExpanded: !this.state.isMaterialExpanded})}
                >
                  <span>{i18nService.translate("detail_view_product_information")}</span>
                  {this.state.isMaterialExpanded ? icons.renderChevronUpIcon() : icons.renderChevronDownIcon()}
                </div>

                {this.state.isMaterialExpanded && (
                  <>
                    {this.props.variant.components.length > 0 && <div className={styles["list"]}>
                      {this.props.variant.components.map(component => (
                        <div>
                            <span
                              className={styles["label"]}>{i18nService.translate(component.translationKey())}: </span>
                          <span>{component.materials.map(material => `${material.value}% ${i18nService.translate(material.translationKey())}`).join(", ")}</span>
                        </div>
                      ))}
                    </div>}

                    {NY_CountryService.getCountryCode() == "fr" && (
                      <>
                        <div className={styles["epr"]}>
                          <span onClick={this.showEpr.bind(this)}>{i18nService.translate("detail_view_epr_label")}</span>
                        </div>

                        <Epr
                          show={this.state.showEpr}
                          onClose={() => this.setState({showEpr: false})}
                          variant={this.props.variant}
                        />
                      </>
                    )}
                  </>
                )}
              </div>

              <div className={styles.separator}/>
            </>
          )}

          {this.props.variant.has_battery &&
            <>
              <div className={`${styles["additional-container"]} ${styles['disposal-hint']}`}>
                <div
                    className={styles["title"]}
                    onClick={() => this.setState({isDisposalHintExpanded: !this.state.isDisposalHintExpanded})}
                >
                  <span>{i18nService.translate("detail_view_disposal_instructions_title")}</span>
                  <span className={styles["icon"]}>{icons.renderCrossedOutWheeledBinIcon()}</span>

                  {this.state.isDisposalHintExpanded ? icons.renderChevronUpIcon() : icons.renderChevronDownIcon()}
                </div>

                {this.state.isDisposalHintExpanded && (
                  <>
                    <div className={styles['details']}>
                      {i18nService.translate("detail_view_disposal_instructions_text")}
                    </div>
                  </>
                )}
              </div>

              <div className={styles.separator}/>
          </>
        }

          <ShootingSize variant={variant}/>
        </div>
        <Colors product={this.props.product} selected={variant}/>
        <MatchingProducts productId={variant.productId} variantId={variant.id} isMobile={true}/>
      </div>
    )
  }

  async handleToggleLike(e: Event) {
    e.stopPropagation();

    await this.props.toggleLike(this.props.variant, !this.state.isLiked, Dimension.DETAIL);
    this.updateLikeState();
  }
}

export default connect(mapToProps, actions)(ProductInfoMobile)
